import dynamic from 'next/dynamic';

export default {
  // Navigation
  FooterMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/FooterMenu')),
  Footer: dynamic(() => import('@eneco/sitecore-components-content/Footer/Footer')),
  // @todo remove this when sitecore has finished migrating the footer
  FooterNew: dynamic(() => import('@eneco/sitecore-components-content/Footer/Footer')),
  LanguageSelector: dynamic(() => import('@eneco/sitecore-components-content/LanguageSelector/LanguageSelector')),
  Logo: dynamic(() => import('@eneco/sitecore-components-eneco/ImageLink/ImageLink')),
  MainNavigation: dynamic(() => import('@apps/header-shared-multilabel/Header')),
  MegaMenu: dynamic(() => import('@eneco/sitecore-components-content/MegaMenu/MegaMenu')),
  MegaMenuV2: dynamic(() => import('@eneco/sitecore-components-content/MegaMenuV2/MegaMenuV2')),
  MegaMenuDivision: dynamic(() => import('@eneco/sitecore-components-content/MegaMenuDivision/MegaMenuDivision')),
  MessageBar: dynamic(() => import('@eneco/sitecore-components-content/MessageBar/MessageBar')),
  NotificationsBar: dynamic(() => import('@eneco/sitecore-components-content/NotificationsBar/NotificationsBar')),
  SubFooterMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/SubFooterMenu')),
  SocialMediaMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/SocialMediaMenu')),

  // Content components
  PromoBox: dynamic(() => import('@eneco/sitecore-components-content/PromoBox/PromoBox')),
  ContentCategories: dynamic(() => import('@eneco/sitecore-components-content/ContentCategories/ContentCategories')),
  ChatLinks: dynamic(() => import('@eneco/sitecore-components-content/ChatLinks/ChatLinks')),
  Accordion: dynamic(() => import('@eneco/sitecore-components-content/Accordion/Accordion')),
  Hero: dynamic(() => import('@eneco/sitecore-components-content/Hero/Hero')),
  HeroRebranded: dynamic(() => import('@eneco/sitecore-components-content/HeroRebranded/HeroRebranded')),
  NotificationBox: dynamic(() => import('@eneco/sitecore-components-content/NotificationBox/NotificationBox')),
  TopTasks: dynamic(() => import('@eneco/sitecore-components-content/TopTasks/TopTasks')),
  ContactCustomerService: dynamic(
    () => import('@eneco/sitecore-components-content/ContactCustomerService/ContactCustomerService'),
  ),
  IconList: dynamic(() => import('@eneco/sitecore-components-content/IconList/IconList')),
  Image: dynamic(() => import('@eneco/sitecore-components-content/Image/Image')),
  List: dynamic(() => import('@eneco/sitecore-components-content/List/List')),
  HeroCard: dynamic(() => import('@eneco/sitecore-components-content/HeroCard/HeroCard')),
  HeroCardRebranded: dynamic(() => import('@eneco/sitecore-components-content/HeroCardRebranded/HeroCardRebranded')),
  LinkCard: dynamic(() => import('@eneco/sitecore-components-content/LinkCard/LinkCard')),
  Price: dynamic(() => import('@eneco/sitecore-components-content/Price/Price')),
  SimpleTable: dynamic(() => import('@eneco/sitecore-components-content/SimpleTable/SimpleTable')),
  TextStreamer: dynamic(() => import('@eneco/sitecore-components-content/TextStreamer/TextStreamer')),
  ButtonLink: dynamic(() => import('@eneco/sitecore-components-content/ButtonLink/ButtonLink')),
  ButtonLineUp: dynamic(() => import('@eneco/sitecore-components-content/ButtonLineUp/ButtonLineUp')),

  // Other
  CookieWall: dynamic(() => import('@apps/cookiewall-nl-multilabel/CookieWall')),
  ErrorPage: dynamic(() => import('@eneco/sitecore-components-content/ErrorPage/ErrorPage')),
  GTM: dynamic(() => import('@apps/gtm-shared-multilabel')),
  MetaData: dynamic(() => import('@eneco/sitecore-components-system/MetaData/MetaData')),
  MetaTags: dynamic(() => import('@eneco/sitecore-components-system/MetaTags/MetaTags')),
  StructuredDataSchema: dynamic(
    () => import('@eneco/sitecore-components-system/StructuredDataSchema/StructuredDataSchema'),
  ),

  // Wrapper components
  Article: dynamic(() => import('@eneco/sitecore-components-content/Article/Article')),
  Centered: dynamic(() => import('@eneco/sitecore-components-content/Centered/Centered')),
  Section: dynamic(() => import('@eneco/sitecore-components-content/Section/Section')),
  LineUp: dynamic(() => import('@eneco/sitecore-components-content/LineUp/LineUp')),
  NavigationView: dynamic(() => import('@eneco/sitecore-components-content/NavigationView/NavigationView')),
  SplitView: dynamic(() => import('@eneco/sitecore-components-content/SplitView/SplitView')),
  Carousel: dynamic(() => import('@eneco/sitecore-components-content/Carousel/Carousel')),

  // Wrappable components
  ArticleCard: dynamic(() => import('@eneco/sitecore-components-content/ArticleCard/ArticleCard')),
  ContentCard: dynamic(() => import('@eneco/sitecore-components-content/ContentCard/ContentCard')),
  ContentCardRebranded: dynamic(
    () => import('@eneco/sitecore-components-content/ContentCardRebranded/ContentCardRebranded'),
  ),
  ProductCard: dynamic(() => import('@eneco/sitecore-components-content/ProductCard/ProductCard')),
  StickyNav: dynamic(() => import('@eneco/sitecore-components-content/StickyNav/StickyNav')),
  Table: dynamic(() => import('@eneco/sitecore-components-content/Table/Table')),
  TitleTextCTA: dynamic(() => import('@eneco/sitecore-components-content/TitleTextCTA/TitleTextCTA')),
  PersonalizedTitleTextCTA: dynamic(
    () => import('@eneco/sitecore-components-content/PersonalizedTitleTextCTA/PersonalizedTitleTextCTA'),
  ),
  Checklist: dynamic(() => import('@eneco/sitecore-components-content/Checklist/Checklist')),
  USPItem: dynamic(() => import('@eneco/sitecore-components-content/USPItem/USPItem')),
  Video: dynamic(() => import('@eneco/sitecore-components-content/Video/Video')),
  ShareOnSocials: dynamic(() => import('@eneco/sitecore-components-content/ShareOnSocials/ShareOnSocials')),

  // Campaign components
  TextImageRebranded: dynamic(() => import('@eneco/sitecore-components-content/TextImageRebranded/TextImageRebranded')),

  // Forms
  GenericForm: dynamic(() => import('@eneco/sitecore-components-forms/GenericForm/GenericForm')),
  GenericFormAddressField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormAddress/GenericFormAddressField'),
  ),
  GenericFormNameField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormNameField/GenericFormNameField'),
  ),
  GenericFormParagraph: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormParagraph/GenericFormParagraph'),
  ),
  GenericFormSalutationField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormSalutation/GenericFormSalutation'),
  ),
  GenericFormRadioGroup: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormRadioGroup/GenericFormRadioGroup'),
  ),
  GenericFormCheckboxField: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormCheckboxField/GenericFormCheckboxField'),
  ),
  GenericFormCheckboxGroup: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormCheckboxGroup/GenericFormCheckboxGroup'),
  ),
  GenericFormDateField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormDateField/GenericFormDateField'),
  ),
  GenericFormEmailInputField: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormEmailInputField/GenericFormEmailInputField'),
  ),
  GenericFormNumberInputField: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormNumberInputField/GenericFormNumberInputField'),
  ),
  GenericFormPhoneNumberInputField: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormPhoneNumberInputField/GenericFormPhoneNumberInputField'),
  ),
  GenericFormInputField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormInputField/GenericFormInputField'),
  ),
  GenericFormTextAreaInputField: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormTextAreaInputField/GenericFormTextAreaInputField'),
  ),
  GenericFormInputSelect: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormInputSelect/GenericFormInputSelect'),
  ),
  GenericFormDivider: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormDivider/GenericFormDivider'),
  ),
};
